import React from 'react'

const AboutPage = () => {  
  return (    
    <div className='text_container'>
      <h1>About Us</h1>
      <p>In order to make the best decision, it's good to have all the facts at your fingertips. We are one of the worls best price and product comparison services, with one single goal - to guide consumers to smarter buying decisions.</p>
      <h3>Find the right product</h3>
      <p>We want you to buy the right product. That's why we gather as many facts as we can, and that's why we have developed one of the world's most comprehensive filters. Our filter helps you find products that suit your needs.</p>
      <ul>
          <li>A huge set of products</li>
          <li>Comprehensive filters - find products that suit you</li>
          <li>See what's popular - the most clicked on products on top on each category page</li>
          <li>Product reviews, written by other users</li>
      </ul>
      <h3>Find the right price</h3>
      <p>We want all consumers to buy at the right price. That's why we gather prices from all online shops that we know of, You can always trust that we show the lowest price at the top of our product pages, since nobody can pay their way to a higher ranking in the price list.</p>
      <ul>
          <li>A huge set of prices from a huge set of British shops</li>
          <li>Price history for every product - see if the price is good right now</li>
          <li>Shop and product reviews, written by other users</li>
      </ul>
      <h3>Even more benefits with our free membership</h3>
      <p>If you use ScoutVendor regularly, we recommend that you become a member. It's free and it gives you a lot of advantages. For example, it's easier to monitor price changes, write reviews, and save product lists.</p>
      <ul>
          <li>Easier to set up and change price alerts</li>
          <li>Save and sync your product lists</li>
          <li>Write reviews on products</li>
      </ul>
      <h3>We are free and always on your side</h3>
      <p>For you as a consumer, it's free to use our price and product comparison service. We don't make money on selling anything and dot want you to buy more than whas necessary. Our mission is to guide you to the best purchase, when you have decided on one.</p>
      <p>We always show all prices that we know of, and you can always trust that we show them from the lowest to the highest. We always build our service around you, as a consumer.</p>
      <p>Make smarter purchase decisions with us!</p>
    </div>
  )
}

export default AboutPage